export default "__VITE_ASSET__DsLBY89b__"